import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Dashboard from "./Pages/Dashboard/Dashboard";
import DecisionMaker from "./Pages/AiDecisionMakers/Index";
import AILeads from "./Pages/AiLeads/Index";
import AiProfile from "./Pages/AiProfile/Index";
import ProfileFormTable from "./Pages/AiProfile/ProfileFormTable/Index";
import ProspectProfile from "./Pages/AiProfile/AiProspectProfile/Index";
import Login from "./Components/Auth/Login/Login";
import { Security } from "@okta/okta-react";
import { OktaAuth } from "@okta/okta-auth-js";
import CompanyProfileScreen from "./Pages/AiLeads/CompanyProfileScreen/Index";
import TwitterFeed from "./Components/TwitterFeed/TwitterFeed";
import { ToastContainer } from "react-toastify";
import { SetOktaIssuer } from "./Utils/Utils";
import {
  AI_DECISION_MAKER,
  AI_LEADS,
  AI_PATH,
  AI_PROFILE,
  AI_PROFILE_FORM_TABLE,
  AI_PROSPECT_PROFILE,
  COMING_SOON,
  COMPANY_PROFILE_SCREEN,
  CONTACT_US,
  DASHBOARD,
  FAQ_SCREEN,
  JOI_TRAINING,
  ATLAS_TRAINING,
  ATLAS_PROMPT_LIBRARY,
  LOGIN,
  LOGIN_CALLBACK,
  PDF_SAMPLE,
  TWITTER_FEED,
  ARCHIVED,
  SCHEDULED_REPORTS,
  FAVORITES,
  DATA_ENRICH,
  TRACKING,
  PROFILE,
  BRE,
  LEGISLATIVE_MAP,
  ERROR_SCREEN,
  MAINTENANCE,
  FAVORITES_LIST,
  PROSPECT_SEARCH_RESULTS,
  ORGANIZATION_SEARCH_RESULTS,
  ATLAS_CHAT,
  M_PROSPECTS,
  M_DASHBOARD,
  M_AI_PATHS,
  M_AI_LEADS,
} from "./Utils/Constants";
import ContactUs from "../src/Pages/ContactUs/Index";
import FaqLayout from "./Pages/FAQ/Index";
import Comingsoon from "./Components/ComingSoon/ComingSoon";
import LoginVerify from "./Components/Auth/Login/LoginVerify";
import PDFSample from "./Components/AiLeads/CompanyProfile/PDF/Index";
import CombinedPDFComponent from "./Pages/AiLeads/PDFDATA/CombinedData";
import JoiTraining from "./Pages/JoiTraining/Index";
import AtlasTraining from "./Pages/AtlasTraining/Index";
import AtlasPromptLibrary from "./Pages/AtlasPromptLibrary/Index";
import ReactGA from "react-ga4";
import Archived from "./Pages/ArchivedRecords/Archived";
import ScheduledReports from "./Pages/ScheduledReports/ScheduledReports";
import Favorites from "./Pages/Favorites/Favorites";
import DataEnrich from "./Pages/DataEnrich/DataEnrich";
import Tracking from "./Pages/Tracking/Tracking";
import Profile from "./Pages/ProspectProfile/Profile";
import BusinessRE from "./Pages/BusinessRE/BusinessRE";
import AIPath from "./Pages/AiPath/AiPathFilters/Index";
import Maintenance from "./Pages/ErrorAndMaintenance/Maintenance";
import ErrorScreen from "./Pages/ErrorAndMaintenance/ErrorScreen";
import FavoritesList from "./Pages/FavoriteList/FavoritesList";
import { authClient, isOktaDisabled } from "./Utils/Common";
import ProspectSearchResults from "./Components/Header/PeopleSearch/ProspectSearchResults";
import OrganizationSearchResults from "./Components/Header/OrganizationSearch/OrganizationSearchResults";
import LegislativeMap from "./Pages/LegislativeMap/LegislativeMap";
import AtlasChatPage from "./Pages/AtlasChatPage/AtlasChatPage";
import RequireAuth from "./Utils/RequireAuth";

function App() {
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    window.location.replace(originalUri);
  };
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  }, [window.location]);
  return (
    <div className="App">
      <Router>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <Security oktaAuth={authClient} restoreOriginalUri={restoreOriginalUri}>
          <Routes>
            <Route path={LOGIN} element={<Login />} />
            <Route path={LOGIN_CALLBACK} element={<LoginVerify />} />

            {/* Protected Routes */}
            <Route
              path={DASHBOARD}
              element={
                <RequireAuth>
                  <Dashboard />
                </RequireAuth>
              }
            />
            <Route
              path={AI_LEADS}
              element={
                <RequireAuth>
                  <AILeads />
                </RequireAuth>
              }
            />
            <Route
              path={AI_DECISION_MAKER}
              element={
                <RequireAuth>
                  <DecisionMaker />
                </RequireAuth>
              }
            />
            <Route
              path={AI_PATH}
              element={
                <RequireAuth>
                  <AIPath />
                </RequireAuth>
              }
            />
            <Route
              path={AI_PROFILE}
              element={
                <RequireAuth>
                  <AiProfile />
                </RequireAuth>
              }
            />
            <Route
              path={AI_PROFILE_FORM_TABLE}
              element={
                <RequireAuth>
                  <ProfileFormTable />
                </RequireAuth>
              }
            />
            <Route
              path={AI_PROSPECT_PROFILE}
              element={
                <RequireAuth>
                  <ProspectProfile />
                </RequireAuth>
              }
            />
            <Route
              path={COMPANY_PROFILE_SCREEN}
              element={
                <RequireAuth>
                  <CompanyProfileScreen />
                </RequireAuth>
              }
            />
            <Route
              path={ATLAS_TRAINING}
              element={
                <RequireAuth>
                  <AtlasTraining />
                </RequireAuth>
              }
            />
            <Route
              path={ATLAS_PROMPT_LIBRARY}
              element={
                <RequireAuth>
                  <AtlasPromptLibrary />
                </RequireAuth>
              }
            />
            <Route
              path={JOI_TRAINING}
              element={
                <RequireAuth>
                  <JoiTraining />
                </RequireAuth>
              }
            />
            <Route
              path={ARCHIVED}
              element={
                <RequireAuth>
                  <Archived />
                </RequireAuth>
              }
            />
            <Route
              path={SCHEDULED_REPORTS}
              element={
                <RequireAuth>
                  <ScheduledReports />
                </RequireAuth>
              }
            />
            <Route
              path={FAVORITES}
              element={
                <RequireAuth>
                  <Favorites />
                </RequireAuth>
              }
            />
            <Route
              path={FAVORITES_LIST}
              element={
                <RequireAuth>
                  <FavoritesList />
                </RequireAuth>
              }
            />
            <Route
              path={DATA_ENRICH}
              element={
                <RequireAuth>
                  <DataEnrich />
                </RequireAuth>
              }
            />
            <Route
              path={TRACKING}
              element={
                <RequireAuth>
                  <Tracking />
                </RequireAuth>
              }
            />
            <Route
              path={PROFILE}
              element={
                <RequireAuth>
                  <Profile />
                </RequireAuth>
              }
            />
            <Route
              path={BRE}
              element={
                <RequireAuth>
                  <BusinessRE />
                </RequireAuth>
              }
            />
            <Route
              path={LEGISLATIVE_MAP}
              element={
                <RequireAuth>
                  <LegislativeMap />
                </RequireAuth>
              }
            />
            <Route
              path={ATLAS_CHAT}
              element={
                <RequireAuth>
                  <AtlasChatPage />
                </RequireAuth>
              }
            />
            <Route
              path={PROSPECT_SEARCH_RESULTS}
              element={
                <RequireAuth>
                  <ProspectSearchResults />
                </RequireAuth>
              }
            />
            <Route
              path={ORGANIZATION_SEARCH_RESULTS}
              element={
                <RequireAuth>
                  <OrganizationSearchResults />
                </RequireAuth>
              }
            />

            <Route path={TWITTER_FEED} element={<TwitterFeed />} />
            <Route path={CONTACT_US} element={<ContactUs />} />
            <Route path={FAQ_SCREEN} element={<FaqLayout />} />
            <Route path={COMING_SOON} element={<Comingsoon />} />
            <Route path={PDF_SAMPLE} element={<PDFSample />} />
            <Route path={"/combinedData"} element={<CombinedPDFComponent />} />
            <Route path="*" element={<ErrorScreen />} />
            <Route path={MAINTENANCE} element={<Maintenance />} />
          </Routes>
        </Security>
      </Router>
    </div>
  );
}
export default App;
